export default function () {
  return {
    quotes: {},
    quotesErrors: {},
    quotesLoading: {}
  };
}
